import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { timeout } from "rxjs/operators";
import {
	SaldoMovimiento,
	SaldoTipoMovimiento,
} from "src/app/models/Saldo/SaldoMovimiento";
import { SaldoResumen } from "src/app/models/Saldo/SaldoResumen";
import { SaldoService } from "src/app/services/saldo.service";

@Component({
	selector: "app-mi-billetera",
	templateUrl: "./mi-billetera.component.html",
	styleUrls: ["./mi-billetera.component.scss"],
})
export class MiBilleteraComponent implements OnInit {
	public resumen: SaldoResumen = {
		tieneCuenta: false,
		saldoContable: 0,
		saldoReservado: 0,
		saldoDisponible: 0,
		moneda: "CLP",
	};
	public movimientos: SaldoMovimiento[] = [];
	public totalMovimientos = 0;
	public pagina = 1;
	public readonly tamanoPagina = 10;
	public cargando = false;
	public cargandoMovimientos = false;
	public error = "";
	public errorMovimientos = "";
	private resumenCargado = false;

	constructor(
		private saldoService: SaldoService,
		private changeDetector: ChangeDetectorRef
	) {}

	public ngOnInit(): void {
		this.cargar(1);
	}

	public cargar(pagina = this.pagina): void {
		if (this.cargando || this.cargandoMovimientos || pagina < 1 || (pagina > this.totalPaginas && this.totalMovimientos > 0)) return;

		this.error = "";

		if (!this.resumenCargado) {
			this.cargando = true;
			this.saldoService.obtenerResumen()
				.pipe(timeout(30000))
				.subscribe(
					(resumen) => {
						this.resumen = resumen;
						this.resumenCargado = true;
						this.cargando = false;
						this.cargarMovimientos(pagina);
						this.changeDetector.detectChanges();
					},
					() => {
						this.cargando = false;
						this.registrarError();
						this.changeDetector.detectChanges();
					}
				);
			return;
		}

		this.cargarMovimientos(pagina);
	}

	public refrescar(): void {
		this.resumenCargado = false;
		this.cargar(this.pagina);
	}

	public get totalPaginas(): number {
		return Math.max(1, Math.ceil(this.totalMovimientos / this.tamanoPagina));
	}

	public etiquetaMovimiento(movimiento: SaldoMovimiento): string {
		switch (movimiento.tipo) {
			case SaldoTipoMovimiento.Generacion:
				return "Saldo generado";
			case SaldoTipoMovimiento.Aplicacion:
				return "Saldo utilizado";
			case SaldoTipoMovimiento.Ajuste:
				return movimiento.ajusteEsCredito ? "Ajuste a favor" : "Corrección de saldo";
			case SaldoTipoMovimiento.Devolucion:
				return "Devolución registrada";
			default:
				return "Movimiento";
		}
	}

	public detalleMovimiento(movimiento: SaldoMovimiento): string {
		if (movimiento.motivo) return movimiento.motivo;

		switch (movimiento.destino) {
			case 1:
				return "Contratación de plan";
			case 2:
				return "Extensión de plan";
			case 3:
				return "Cambio de plan";
			case 4:
				return "Compra de adicional";
			case 5:
				return "Compra de certificación";
			default:
				return "Movimiento confirmado";
		}
	}

	public trackMovimiento(_: number, movimiento: SaldoMovimiento): string {
		return movimiento.saldoMovimientoId;
	}

	private cargarMovimientos(pagina: number): void {
		this.cargandoMovimientos = true;
		this.errorMovimientos = "";
		this.saldoService.obtenerMovimientos(pagina, this.tamanoPagina)
			.pipe(timeout(30000))
			.subscribe(
				(resultado) => {
					this.asignarMovimientos(resultado);
					this.cargandoMovimientos = false;
					this.changeDetector.detectChanges();
				},
				() => {
					this.cargandoMovimientos = false;
					this.errorMovimientos = "No fue posible cargar los movimientos. Intenta nuevamente.";
					this.changeDetector.detectChanges();
				}
			);
	}

	private asignarMovimientos(resultado: {
		items: SaldoMovimiento[];
		total: number;
		pagina: number;
	}): void {
		this.movimientos = resultado.items;
		this.totalMovimientos = resultado.total;
		this.pagina = resultado.pagina;
	}

	private registrarError(): void {
		this.error = "No fue posible cargar la información de tu billetera. Intenta nuevamente.";
	}
}
